import { goBot, cleanGistEvent } from './components/help';
global.goBot = goBot;
global.cleanGistEvent = cleanGistEvent;
